import { render } from "./ListeDocument.vue?vue&type=template&id=b95c9c68&ts=true"
import script from "./ListeDocument.vue?vue&type=script&lang=ts"
export * from "./ListeDocument.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__